import { registerHandler } from '../paymentHandlerRegistry';

/**
 * Default credit card handler.
 * Fallback handler for credit card payments when no engine-specific handler matches.
 * Submits the standard card form via redux-form.
 */
registerHandler('credit_card', {
  execute: async ({ onSubmitForm }) => {
    onSubmitForm('card');
  },
});
